<template>
  <v-container fluid style="max-width: 1000px; padding: 0px 20px">
    <v-row>
      <v-col color="dark_grey --text" cols="12">
        <h2>
          Guten Tag {{ user.name }}
        </h2>
      </v-col>
    </v-row>
    <v-row class="d-flex">
      <inertia-link :href="route('customer.create')" class="col-md-4 col-lg-3 col-6" v-on="on">
        <v-btn class="mb-6 content-expand" color="grey_light" height="200" width="200" @click="$root.drawer = false">
          <span class="tooltip-inside primary--text">
            neuen Kunden <br>anlegen
          </span>
          <v-icon class="mb-6" size="100px" color="primary">
            mdi-account-plus-outline
          </v-icon>
        </v-btn>
      </inertia-link>

      <inertia-link :href="route('customer.index')" class="col-md-4 col-lg-3 col-6" v-on="on">
        <v-btn class="mb-6 content-expand" color="grey_light" height="200" width="200" @click="$root.drawer = false">
          <span class="tooltip-inside primary--text">
            Kundenübersicht
          </span>
          <v-icon class="mb-6" size="100px" color="primary">
            mdi-account-group-outline
          </v-icon>
        </v-btn>
      </inertia-link>

      <inertia-link :href="route('offerData.index')" class="col-md-4 col-lg-3 col-6" v-on="on">
        <v-btn class="mb-6 content-expand" color="grey_light" height="200" width="200" @click="$root.drawer = false">
          <span class="tooltip-inside primary--text">
            Preis <br> Informationen
          </span>
          <v-icon class="mb-6" size="100px" color="primary">
            mdi-information-variant
          </v-icon>
        </v-btn>
      </inertia-link>

      <inertia-link :href="route('offer.index',{type: 1})" class="col-md-4 col-lg-3 col-6" v-on="on">
        <v-btn class="mb-6 content-expand" color="grey_light" height="200" width="200" @click="$root.drawer = false">
          <span class="tooltip-inside primary--text">freigegebene <br> Angebote</span>
          <v-icon class="mb-6" size="100px" color="primary">
            mdi-clipboard-check-outline
          </v-icon>
        </v-btn>
      </inertia-link>

      <inertia-link :href="route('offer.index',{type: 2})" class="col-md-4 col-lg-3 col-6" v-on="on">
        <v-btn class="mb-6 content-expand" color="grey_light" height="200" width="200" @click="$root.drawer = false">
          <span class="tooltip-inside primary--text">
            Angebotsprozess
          </span>
          <v-icon class="mb-6" size="100px" color="primary">
            mdi-timer-sand
          </v-icon>
        </v-btn>
      </inertia-link>

      <inertia-link :href="route('offer.index', {type: 3})" class="col-md-4 col-lg-3 col-6" v-on="on">
        <v-btn class="mb-6 content-expand" color="grey_light" height="200" width="200" @click="$root.drawer = false">
          <span class="tooltip-inside primary--text">angenommene <br> Angebote</span>
          <v-icon class="mb-6" size="100px" color="primary">
            mdi-clipboard-text-outline
          </v-icon>
        </v-btn>
      </inertia-link>

      <inertia-link :href="route('contract.index')" class="col-md-4 col-lg-3 col-6" v-on="on">
        <v-btn class="mb-6 content-expand" color="grey_light" height="200" width="200" @click="$root.drawer = false">
          <span class="tooltip-inside primary--text">Verträge</span>
          <v-icon class="mb-6" size="100px" color="primary">
            mdi-clipboard-clock-outline
          </v-icon>
        </v-btn>
      </inertia-link>

      <inertia-link :href="route('offer.index', {type: 9})" class="col-md-4 col-lg-3 col-6" v-on="on">
        <v-btn class="mb-6 content-expand" color="grey_light" height="200" width="200" @click="$root.drawer = false">
          <span class="tooltip-inside primary--text">abgelehnte <br> Angebote</span>
          <v-icon class="mb-6" size="100px" color="primary">
            mdi-clipboard-text-off-outline
          </v-icon>
        </v-btn>
      </inertia-link>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo: { title: 'Dashboard' },

   layout: (h, page) => h(Layout, [page]),

   props: {
      user: {
         required: true,
         type: Object
      }
   },

   data () {
      return {}
   },
}
</script>

<style>
.absolute-center{
    position: absolute;
    top: 50px;
    left: 50px;
}
.tooltip-inside{
    position: absolute;
    bottom: 15px;
    left: 0px;
    right: 0px;
    /* background-color: rgba(0, 0, 0, 0.36); */
    /* color: white; */
    border-radius: 3.5px;
    text-align: center;
    min-height: 50px;
}
.content-expand > span{
    height: 100%;
    width: 100%;
}
</style>
